import pkg from '../../../packages/core/package.json';

const version = pkg.version;

export default version;
